import { serializeFilter as serializeAttributeFilter } from 'cio/utils/conditions/serialize/attribute';
import { canSelectComparisonOperator } from 'cio/app-models/conditions/attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';

export default function serializeCollectionAttribute(
  obj: CollectionAttributeCondition,
  useInverse = false,
  addType = false,
  useComparisonOperator = false,
): SerializedLegacyAttributeFilter {
  let result: SerializedLegacyAttributeFilter = { ...serializeAttributeFilter(obj, useInverse, false, false) };

  if (addType) {
    result.type = 'collection_attribute';
  }

  if (useComparisonOperator && canSelectComparisonOperator(obj.operator)) {
    if (obj.comparisonOperator !== 'value') {
      result = {
        ...result,
        type: 'attribute_compare',
        field_source: 'collection_attribute',
        value_source: obj.comparisonOperator,
      };
    }
  }

  return result;
}
